import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';
import './TypoContainer.sass';

interface Props {
	markup: string;
}

function TypoContainer(props: Props) {
	return (
		<div className="uikit-typo-container">
			{ReactHtmlParser(props.markup, {
				transform: transformSource,
			})}
		</div>
	);
}

export default TypoContainer;
